export interface DiscoveryRequest {
  request_id: string;
  connector_account_id: string;
  country_code: string;
  access_code?: string;
  destination_code?: string;
  language?: string;
}
export interface DiscoveryJob {
  job_id: string;
  connector: 'travelgate' | 'hotelbeds';
  connector_account_id: string;
  account_name: string;
  access_code: string | null;
  country_code: string;
  destination_code: string | null;
  language: string | null;
  status: 'queued' | 'claimed' | 'completed' | 'retryable_failed' | 'terminal_failed';
  pages_processed: number;
  hotels_processed: number;
  attempt_count: number;
  last_error_code: string | null;
  created_at: string;
  updated_at: string;
  completed_at: string | null;
}
export interface DiscoveredHotel {
  supplier_hotel_id: number;
  connector: string;
  connector_account_id: string;
  hotel_code: string;
  native_hotel_code: string | null;
  access_code: string | null;
  supplier_code: string | null;
  provider_code: string | null;
  display_name: string | null;
  country_code: string | null;
  locality: string | null;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  fastx_codes: string[];
  received_at: string;
  current_hotel_id: string | null;
  link_status: 'active' | 'disabled' | null;
}
export interface DiscoveryPage<T> {
  data: T[];
  meta: { count: number; limit: number; offset: number; has_more: boolean };
}
export const discoveryPending = (status?: string) => !!status && !['completed', 'terminal_failed'].includes(status);
export function discoveryCsvCell(value: unknown) {
  let text = String(value ?? '');
  if (/^[\s]*[=+\-@\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}
export async function discoveryCsv(
  fetchPage: (offset: number) => Promise<DiscoveryPage<DiscoveredHotel>>,
  cancelled: () => boolean,
  progress: (count: number) => void,
) {
  const columns = [
    'supplier_hotel_id',
    'hotel_code',
    'native_hotel_code',
    'display_name',
    'country_code',
    'locality',
    'address',
    'connector',
    'connector_account_id',
    'access_code',
    'fastx_codes',
    'current_hotel_id',
  ] as const;
  const lines = [columns.join(',')];
  let offset = 0;
  const seen = new Set<number>();
  for (;;) {
    if (cancelled()) throw new Error('cancelled');
    const page = await fetchPage(offset);
    if (cancelled()) throw new Error('cancelled');
    if (
      page.meta.offset !== offset ||
      page.meta.limit !== 100 ||
      page.data.length !== page.meta.count ||
      (page.meta.has_more && page.data.length !== 100)
    ) throw new Error('page');
    for (const row of page.data) {
      if (seen.has(row.supplier_hotel_id)) throw new Error('duplicate');
      seen.add(row.supplier_hotel_id);
      lines.push(
        columns.map((k) => discoveryCsvCell(k === 'fastx_codes' ? row.fastx_codes.join('|') : row[k])).join(','),
      );
    }
    progress(seen.size);
    if (!page.meta.has_more) return `\uFEFF${lines.join('\r\n')}`;
    offset += page.data.length;
    if (offset >= 100000) throw new Error('export_limit');
  }
}
